export const BASE_URL = "https://app.reghub.io/RegHub_webservices/api";
export const REGHUB_WEB_SERVICES =
  "https://www.reghub.io/RegHub_webservices/api/RegHubwebservice";
export const MAIN_WEBSITE_URL = "https://www.reghub.io/";
export const CURRENT_COVERAGE_URL =
  "https://www.reghub.io/blog/country-coverage/";
export const LEARN_MORE_URL =
  "https://www.reghub.io/blog/how-to-start-using-reghub/";
export const REG_HUB_ADD_TOPIC = "https://www.reghub.io/blog/addtopic/";

/* Topics urls */
export const GET_TOPICS = BASE_URL + "/getTopics";
export const ADD_TOPIC = BASE_URL + "/addTopic";
export const DELETE_TOPIC = BASE_URL + "/deleteTopic";
export const UPDATE_TOPIC = BASE_URL + "/updateTopic";
export const SUBSCRIBE_TOPIC = BASE_URL + "/subscribeTopic";
export const UNSUBSCRIBE_TOPIC = BASE_URL + "/unsubscribeTopic";
export const GET_USER_SUBSCRIPTION = BASE_URL + "/getUserSubscriptions";

/* User urls */
export const REGISTER = BASE_URL + "/registerUser";
export const LOGIN = BASE_URL + "/login";
export const DELETE_USER = BASE_URL + "/deleteAccount";
export const CHANGE_PASSWORD = BASE_URL + "/changePassword";
export const REQUEST_WORKSPACE = BASE_URL + "/requestWorkspace";
export const CHECK_USER_RIGHTS_URL = BASE_URL + "/checkUserRights";
export const ASK_QUESTION = BASE_URL + "/createLLMAssessment_Complex";

export const ASK_QUESTION_DOCUMENT =
  BASE_URL + "/createLLMAssessment_SingleDocument_Complex";

/* LinkedIn auth */
export const LINKEDIN_OAUTH = "https://www.linkedin.com/oauth/v2/authorization";
export const LINKEDIN_ACCESS_TOKEN = BASE_URL + "/accessLinkedInToken";
export const GET_LINKEDIN_MEMBER = "https://api.linkedin.com/v2/me";

/* Footer links */
export const PRIVACY = "https://www.reghub.io/privacy/";
export const TERMS_OF_USE = "https://www.reghub.io/terms-of-service/";
export const HELLP = "https://www.reghub.io/blog/how-to-start-using-reghub/";

/* Filter links */
export const GET_FILTERS = BASE_URL + "/getFilters";
export const ADD_FILTER = BASE_URL + "/addFilter";
export const DELETE_FILTER = BASE_URL + "/deleteFilter";
export const DELETE_NEWS_BY_ID = BASE_URL + "/deleteNews";
export const ADD_NEWS = BASE_URL + "/addNews";
export const EDIT_NEWS = BASE_URL + "/editNews";
export const GET_REGULATORY_STREAM = BASE_URL + "/getRegulatoryStream";
export const GET_TOP_5_PUBLISHER = BASE_URL + "/getTop5Publisher";
export const GET_TOP_5_COUNTRIES = BASE_URL + "/getTopCountries";
export const GET_GRAPH_AGGREGATION = BASE_URL + "/getGraphAggregation";
export const GET_GRAPH_AGGREGATION_DETAILS =
  BASE_URL + "/getGraphAggregation_Details";
export const GET_HOT_TOPICS_PER_BUSINESS =
  BASE_URL + "/getTopTopics_Business_Units";
export const GET_DOCUMENT = BASE_URL + "/getDocument";
export const GET_SIMILAR_DOCUMENT = BASE_URL + "/getSimilarDocuments";
export const GET_FILTERS_TYPE = BASE_URL + "/getFilterTypes";
export const BOOKMARK_DOCUMENT = BASE_URL + "/bookmarkDocument";
export const CHECK_BOOKMARKING = BASE_URL + "/checkBookmarking";
export const UNBOOKMARK_DOCUMENT = BASE_URL + "/unbookmarkDocument";
export const GENERATE_NEWS = BASE_URL + "/createChatGPTSummary";

/* Tiles links */
export const ADD_TILE = BASE_URL + "/addTile";
export const ADD_TILE_POST = BASE_URL + "/addTile_POST";
export const UPDATE_TILE = BASE_URL + "/updateTile";
export const UPDATE_TILE_POST = BASE_URL + "/updateTile_POST";
export const CHANGE_TILE_NAME = BASE_URL + "/changeTileName";
export const DELETE_TILE = BASE_URL + "/deleteTile";
export const ADD_LINK = BASE_URL + "/addLink";
export const REMOVE_LINK = BASE_URL + "/removeLink";
export const UPDATE_LINK = BASE_URL + "/updateLink";
export const GET_TILES = BASE_URL + "/getTiles";
export const GET_TILE_TYPES = BASE_URL + "/getTileTypeList";
export const ADD_DOCUMENT = BASE_URL + "/addDocument";

/* Manage sources */
export const GET_CRAWLER_SOURCES = BASE_URL + "/getCrawlerSources";
export const ADD_CRAWLER_SOURCES = BASE_URL + "/addCrawlerSource";
export const UPDATE_CRAWLER_SROUCES = BASE_URL + "/updateCrawlerSource";
export const DELETE_CRAWLER_SOURCES = BASE_URL + "/deleteCrawlerSource";
export const PREVIEW_CRAWLER_SOURCES = BASE_URL + "/previewCrawlerSource";
